export const MOBILE_LAYOUT_MAX_WIDTH_QUERY = '(min-width:1250px)';
